import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    title:'打造前程集团',
    pageCount:8,
    selected:0,
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
